import {ReviewSummary} from 'constants/SourceConstants';
import * as net from 'util/Net';

const HomeDashboardDAO = {
  fetchEntryReviewSummary(): JQueryPromise<ReviewSummary> {
    return net.getJSON('/1/api/users/me/review-summary');
  },
  fetchWorksheetReviewSummary(): JQueryPromise<ReviewSummary> {
    return net.getJSON('/1/api/users/me/review-summary?worksheet_reviews_only');
  },
};

export default HomeDashboardDAO;
